import React from "react";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LazyImage,
  // LazyImage,
  TextStyled,
} from "../../../components/styled/Elements";
import { ForgetPassImg, VerifyImg } from "../../../components/styled/AllImages";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const LogoutModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <Box className="d-flex flex-column align-items-center py-3 px-2">
          <Box>
            <HeadingStyled size="24px" className="mb-2 mt-3">
              {t("Logout")}
            </HeadingStyled>
          </Box>
          <Box>
            <TextStyled
              size="16px"
              color="var(--lightGrey)"
              className="text-center px-3 mb-2"
            >
              {t("sureLogout")}
            </TextStyled>
          </Box>
          <Box className="w-100 d-flex justify-content-center gap-3 mt-4">
            <Box>
              <ButtonStyled
                onClick={props.onHide}
                type="button"
                className="w-100"
                bg="var(--bg)"
                color="var(--themeColor)"
                clName="w-100"
                label={t("Cancel")}
              />
            </Box>
            <Box>
              <ButtonStyled
                className="w-100"
                clName="w-100"
                label={t("Logout")}
                isLoading={props.isLoading}
                onClick={props.handleLogout}
              />
            </Box>
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
